export type RecentPurchase = {
  name: string
  city: string
  minutesAgo: number
}

// Reemplazar por compras reales si se conecta la plataforma de pago
export const recentPurchases: RecentPurchase[] = [
  { name: 'Lucía', city: 'CABA', minutesAgo: 2 },
  { name: 'Federico', city: 'Rosario', minutesAgo: 4 },
  { name: 'Marina', city: 'Córdoba', minutesAgo: 6 },
  { name: 'Gastón', city: 'La Plata', minutesAgo: 9 },
  { name: 'Camila', city: 'Mendoza', minutesAgo: 12 },
  { name: 'Hernán', city: 'Mar del Plata', minutesAgo: 15 },
  { name: 'Sofía', city: 'Salta', minutesAgo: 18 },
  { name: 'Julián', city: 'Neuquén', minutesAgo: 21 },
]
